// ======================================================================
// File Name       : SelectBox
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { Form } from 'react-bootstrap';
import * as MessageTemplate from '../constants/MessageTemplate';
import { onChangeWrapper } from '../utils/FormUtils';

class SelectBox extends Component {
  constructor() {
    super();
    this.state = {
      validRequired: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.validation = this.validation.bind(this);
  }

  /**
   * Event change value of FormControl text
   * @param {*} event
   */
  handleChange(event) {
    this.value = event.target.value;
    this.validation();
    if (this.props.onChange) {
      if (this.props.useConvertedValue) {
        onChangeWrapper(this.props.onChange, this.props.value)(event);
      } else {
        this.props.onChange(event);
      }
    }
  }

  validation() {
    let isValid = true;
    const value = this.value ? this.value : this.props.value;
    if (value && this.props.required) {
      this.setState({ validRequired: true });
    } else if (this.props.required) {
      this.setState({ validRequired: false });
      isValid = false;
    }
    return isValid;
  }

  componentWillReceiveProps(newProps) {
    if (typeof newProps.value !== 'undefined') this.value = newProps.value;
  }

  /**
   * Message validate
   * @param {*} label
   * @param {*} msg
   */
  messageTemplate(label, msg) {
    return msg.replace('{0}', label);
  }

  render() {
    const value = this.props.value;
    let selectData = null;
    const valueKey = this.props.valueKey ? this.props.valueKey : 'value';
    const nameKey = this.props.nameKey ? this.props.nameKey : 'name';
    const label = this.props.label;
    if (this.props.data) {
      let index = 1;
      selectData = this.props.data.map((item) => {
        index++;
        return (
          <option
            key={this.props.keyIndex ? `${index}_${this.props.keyIndex}` : index}
            value={item[valueKey]}
          >
            {item[nameKey]}
          </option>
        );
      });
    }
    return (
      <div>
        <Form.Select
          onChange={this.handleChange}
          disabled={this.props.disabled}
          size={this.props.size}
          value={value}
          name={this.props.name}
        >
          {this.props.addingEmptyOption && <option />}
          {selectData}
        </Form.Select>
        {!this.state.validRequired && (
          <p className="message-error">{this.messageTemplate(label, MessageTemplate.W_REQUIRED)}</p>
        )}
      </div>
    );
  }
}

export default SelectBox;
